<div class="virtual-keyboard-component">

  <div class="col-12 title">Informe seu código de segurança</div>

  <div class="spinner" *ngIf="loading">
    <app-spinner-loading></app-spinner-loading>
  </div>

  <div class="keyboard-area virtual" *ngIf="!loading &&  typeSignature !== 'string'">
    <div class="row">
      <mat-form-field class="col-12">
        <input class="key-input" matInput disabled [(ngModel)]="inputToShow">
      </mat-form-field>
    </div>
    <div class="row btn-area">
      <div *ngFor="let item of keysList" class="col-4 key">
        <img [src]="item.ImagemTecla" alt="" (click)="onBtnClick(item)">
      </div>
      <div class="col-4 key clear-btn">
        <span (click)="clearInput()">Limpar</span>
      </div>
    </div>
  </div>

  <div class="keyboard-area string" *ngIf="!loading &&  typeSignature === 'string'">
    <mat-form-field class="col-12">
      <input class="key-input" matInput type="password" minlength="6" maxlength="6" [(ngModel)]="inputToShow"
        (keyup)="validateSignatureValid(inputToShow)" ondragstart="return false;" ondrop="return false;"
        autocomplete="new-password">
    </mat-form-field>
  </div>

</div>